import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Portal } from 'components/Portal';
import { TableValueDynamic } from 'components/ModalCreateClient/components/TableItems';
import { Button } from 'components/Button';
import cn from 'classnames';
import './style.scss';
import { clientApi } from 'helpers/api/client';
import { errorToast } from 'configuration/notifications';
import { getDIIAData } from 'store/cashWarrant/actions';
import { useHistory } from 'react-router';
import { ModalClientDuplication } from 'components/ModalClientDuplication';

const DIIA_CODE_LEN = 13;

const ModalDiia = ({ clientId, onClose, historyParams }) => {
  const history = useHistory();

  const dispatch = useDispatch();

  const [code, setCode] = useState('');
  const [modalClientDuplication, setModalClientDuplication] = useState(false);
  const [INN, setINN] = useState('');
  const isCodeValid = useCallback(() => {
    return !(code.length === DIIA_CODE_LEN && !code.includes('X'));
  }, [code]);

  const handleDuplication = (inn) => {
    setINN(inn);
    setModalClientDuplication(true);
  };

  const handleModalClientDuplication = (result) => {
    return () => {
      setModalClientDuplication(result);
    };
  };

  const handleSubmitClient = async (client) => {
    await clientApi.getClientDIIADocuments(client.id);
    history.push(`client/${client.id}`);
    setModalClientDuplication(false);
    onClose();
  };

  const handleClick = async () => {
    let body = { barcode: code };
    if (clientId) {
      body.clientID = clientId;
    }
    const { data } = await clientApi.sendDIIABarcode(body);
    if (!data?.success) {
      errorToast(`Помилка: ${data.error}`);
    } else {
      await getDIIAData(code, history, dispatch, handleDuplication);
    }
  };
  if (modalClientDuplication) {
    return (
      <ModalClientDuplication
        INN={INN}
        onSubmit={handleSubmitClient}
        onClose={handleModalClientDuplication(false)}
        historyParams={historyParams}
      />
    );
  }
  return (
    <Portal id="modal-diia" className="diia" onClose={onClose}>
      <div className="modal-diia">
        <div className="content-diia">
          {' '}
          <b>Инструкция</b>
          <span>
            {' '}
            <ol>
              <li>
                Попросите клиента:
                <ol className="a" type="a">
                  <li>
                    открыть приложение <b>Дія</b>
                  </li>
                  <li>найти документ Паспорт громадянина України </li>
                  <li>нажать на карточку документа (перевернуть)</li>
                  <li>нажать кнопку “Штрих-код” </li>
                  <li>продиктовать 13 цифр под штрих-кодом.</li>
                </ol>
              </li>{' '}
              <li>Вписать эти цифры в поле справа </li>
              <li>Нажать кнопку “Получить данные” </li>
              <li>
                Попросить клиента подтвердить отправку документов в <b>Дія</b>
              </li>
            </ol>
          </span>
        </div>
      </div>
      <div className="modal-diia diia-form">
        <div className="content-diia">
          {' '}
          <b> Код</b>
          <div className="diia-code">
            <TableValueDynamic
              mask="9999999999999"
              value={code}
              onChange={(value) => {
                setCode(value);
              }}
              placeholder="XXXXXXXXXXXXX"
              styles={{
                padding: '10px 20px',
                lineHeight: '21px',
                fontSize: '16px',
                letterSpacing: '0.25em',
              }}
            />
            <Button
              className={cn('btn-diia', isCodeValid() && 'btn-diia-disabled')}
              disabled={isCodeValid()}
              onClick={handleClick}
            >
              Получить данные
            </Button>
          </div>
        </div>
      </div>
    </Portal>
  );
};

ModalDiia.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  onClose: PropTypes.func.isRequired,
  historyParams: PropTypes.object,
};

ModalDiia.defaultProps = {
  clientId: '',
  historyParams: {},
};

export { ModalDiia };
